import React, { useCallback, useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, ChevronRight } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../i18n";

const ICON = { contract: "📝", stock: "📦", schedule: "🕒", stuck: "⏱️", push: "🔔" };

// Barre d'alertes du tableau de bord vendeur : chaque alerte ouvre l'onglet à corriger
export function VendorAlertsBar({ onGoto, refreshKey }) {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/vendor/alerts").then((r) => setData(r.data)).catch(console.error), []);
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, [load, refreshKey]);
  if (!data) return null;
  if (data.ok) {
    return (
      <div data-testid="vendor-alerts-ok" className="flex items-center gap-2 border border-neon-green/40 bg-neon-green/5 text-neon-green px-4 py-3 mb-6 text-sm font-bold uppercase">
        <CheckCircle2 className="h-5 w-5" /> {t("vd.alerts.ok")}
      </div>
    );
  }
  return (
    <div data-testid="vendor-alerts-bar" className="border border-orange-400/50 bg-orange-400/5 mb-6">
      <div className="flex items-center gap-2 px-4 pt-3 pb-1 text-orange-300 text-xs uppercase font-bold"><AlertTriangle className="h-4 w-4" /> {t("vd.alerts.title")} ({data.alerts.length})</div>
      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 px-3 pb-3">
        {data.alerts.map((a) => (
          <button key={a.code} type="button" data-testid={`vendor-alert-${a.code}`} onClick={() => onGoto(a.tab)}
            className={`min-h-[44px] flex items-center justify-between gap-3 px-3 py-2 text-left text-sm border transition-colors flex-1 sm:flex-none ${a.level === "error" ? "border-red-500/60 text-red-300 hover:bg-red-500/10" : a.level === "warn" ? "border-orange-400/60 text-orange-300 hover:bg-orange-400/10" : "border-zinc-600 text-zinc-300 hover:bg-zinc-800"}`}>
            <span>{ICON[a.code]} {a.count ? `${a.count} ` : ""}{t(`vd.alert.${a.code}`)}</span>
            <span className="inline-flex items-center gap-0.5 text-[10px] uppercase font-bold opacity-80">{t("vd.alert.fix")} <ChevronRight className="h-3 w-3" /></span>
          </button>
        ))}
      </div>
    </div>
  );
}
